import React from 'react'
import { useSelector } from 'react-redux'

import { selectProjectById } from '../api/for-company/projects.api'
import { ForProjectRole } from '../components/Auth/ForProjectRole'
import { ToolbarActions } from '../components/Drawers/Toolbar'
import { ListSummaryPAS } from '../components/PAS/ListPASSummary'
import { AircraftInformationDrawer } from '../components/Projects/AircraftInformation/AircraftInformationDrawer'
import { ProjectRolePermissions } from '../domain/project-role.domain'
import { routes } from '../routes'
import { useAppSelector } from '../store'

import { Page } from './shared/Page'

export const PASSummaryPage: React.FC = () => {
    const { projectId } = routes.RASSummary.useParams()
    const project = useSelector(selectProjectById(projectId))

    if (!project) {
        return null
    }

    return (
        <ForProjectRole permission={ProjectRolePermissions.RASListSubparts} projectId={projectId}>
            <Page logo={project.auditorLogo}>
                <ListSummaryPAS projectId={projectId} />
            </Page>
            <ToolbarActions>
                <ForProjectRole
                    permission={ProjectRolePermissions.AircraftInformationView}
                    projectId={projectId}
                >
                    <AircraftInformationDrawer projectId={projectId} />
                </ForProjectRole>
            </ToolbarActions>
        </ForProjectRole>
    )
}
